import { render, staticRenderFns } from "./ExportRecord.vue?vue&type=template&id=404b1b96&scoped=true&"
import script from "./ExportRecord.vue?vue&type=script&lang=js&"
export * from "./ExportRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExportRecord.vue?vue&type=style&index=0&id=404b1b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b1b96",
  null
  
)

export default component.exports